import React from "react";
import { FormattedMessage } from "react-intl";
import * as styles from "./styles";

const DraftHeader: React.FC = () => {
  return (
    <div className={styles.header}>
      <div className={styles.container}>
        <FormattedMessage
          tagName={"span"}
          id={"components.DraftHeader.readOnlyMode"}
          defaultMessage="Read only-mode (Event is a draft)"
        />
        <FormattedMessage
          tagName={"span"}
          id={"components.DraftHeader.infoText"}
          defaultMessage="You can interact with the event as usual, but you will not be able to purchase a ticket."
        />
      </div>
    </div>
  );
};

export default DraftHeader;
